import { z } from "zod";

/// GET /pulse-surveys/me/answer-replies: whether the workspace setting is on,
/// readable by any member (the admin setting route is not).
export const memberAnswerRepliesSchema = z.object({ enabled: z.boolean() }).strict();
export type MemberAnswerReplies = z.infer<typeof memberAnswerRepliesSchema>;

/// GET /pulse-surveys/me/deliveries/:deliveryId/answer-replies
export const deliveryReplyEligibilitySchema = z.object({ replyEligible: z.boolean() }).strict();
export type DeliveryReplyEligibility = z.infer<typeof deliveryReplyEligibilitySchema>;
